// @flow

import * as React from 'react'
import * as Sentry from '@sentry/browser'
import {connect} from 'react-redux'

import type {State as ReduxState, User} from '../types'

if (
  !['development', 'test'].includes(process.env.NODE_ENV) &&
  window.menageConfig &&
  window.menageConfig.sentryDsn
) {
  Sentry.init({
    dsn: window.menageConfig.sentryDsn,
    ignoreErrors: [
      'Failed to fetch',
      'Network request failed',
      'NetworkError when attempting to fetch resource.',
      'The `Intl` APIs must be available in the runtime',
      'The network connection was lost.',
      'Kan niet ophalen',
      'De internetverbinding is offline.',
      'De netwerkverbinding is verbroken.',
      'Geen verbinding met de server mogelijk.',
      'The Internet connection appears to be offline.',
      'La connexion Internet semble interrompue.',
      'The request timed out.',
      'Time-out van het verzoek.',
      'An SSL error has occurred and a secure connection to the server cannot be made.',
      'Er heeft zich een SSL-fout voorgedaan. Er kan geen veilige verbinding met de server tot stand worden gebracht.',
      'Une erreur SSL s’est produite et il est impossible d’établir une connexion sécurisée avec le serveur.',
      'Es ist ein SSL-Fehler aufgetreten. Eine sichere Verbindung zum Server kann nicht hergestellt werden.',
      'Die Netzwerkverbindung wurde unterbrochen.',
      'Er is geen server gevonden met de opgegeven hostnaam.',
      'Aucun serveur ayant le nom d’hôte précisé n’a pu être trouvé.',
      'Out of memory',
    ],
    ignoreUrls: [/extensions\//i, /^chrome:\/\//i],
  })
}

type Props = {
  children?: React.Node,
  errorNode?: React.Node,
  user: ?User,
}

type State = {
  hasError: boolean,
}

export class ErrorHOC extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  componentDidCatchError(error: any, errorInfo: any) {
    const {user} = this.props
    this.setState({
      hasError: true,
    })
    if (user) {
      Sentry.configureScope(scope => {
        scope.setUser({id: user.token})
      })
    }
    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key])
      })
      Sentry.captureException(error)
    })
  }

  render() {
    if (this.state.hasError && this.props.errorNode) return this.props.errorNode
    if (this.props.children) {
      return this.props.children
    }
    return null
  }
}

const mapStateToProps = (state: ReduxState) => ({
  user: state.user.entity,
})

export default connect(mapStateToProps)(ErrorHOC)
